import { createContext, useContext, useState } from 'react';

const LayoutContext = createContext({
  hideNavbars: false,
  setHideNavbars: () => {},
});

export function LayoutProvider({ children }) {
  const [hideNavbars, setHideNavbars] = useState(false);

  return (
    <LayoutContext.Provider value={{ hideNavbars, setHideNavbars }}>
      {children}
    </LayoutContext.Provider>
  );
}

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    // Fallback if used outside provider (shouldn't happen, but safe)
    return { hideNavbars: false, setHideNavbars: () => {} };
  }
  return context;
};

